export default {"src":"/_next/static/media/check-in-circle-lilac.158ee89e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};